import createClient, { type Client } from 'openapi-fetch';

import type { paths } from './schema';

export interface ApiClientOptions {
  baseUrl: string;
  defaultHeaders?: Record<string, string>;
  fetch?: typeof fetch;
}

export function createApiClient(options: ApiClientOptions): Client<paths> {
  return createClient<paths>({
    baseUrl: options.baseUrl,
    headers: {
      'Content-Type': 'application/json',
      ...options.defaultHeaders,
    },
    ...(options.fetch ? { fetch: options.fetch } : {}),
  });
}

export type ApiClient = Client<paths>;
